Ext.define('SA.RelatedDataTableController', {
    extend: 'SA.ViewController',

    createDefaultView() {
        this.toolbar = new SA.view.RelatedDataViewToolbar({model: this.model});

        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);

        return SA.ProjectView.createHidden({xtype: 'related-data-report-grid', projectView: this.model});
    },

    createEditView() {
        this.editController = new SA.RelatedDataTableEditController(this.getEditControllerParams());

        return SA.ProjectView.createHidden(this.editController.getView());
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.RelatedDataTableExportConfig({model: this.model});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['locations', 'data'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data')
            .setModel(this.model)
            .apply();
    }
});